module.exports = __webpack_public_path__ + "static/media/Assets-06-Books-of-type-02.ee561240.png";